module.exports = __webpack_public_path__ + "img/2 - Edward Steere.e049ebd1.jpg";